import { render, staticRenderFns } from "./RuleBudget.vue?vue&type=template&id=2ad24a0b"
import script from "./RuleBudget.vue?vue&type=script&lang=js"
export * from "./RuleBudget.vue?vue&type=script&lang=js"
import style0 from "./RuleBudget.vue?vue&type=style&index=0&id=2ad24a0b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports